import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useDeleteCard = (onSuccess: () => void) => {
  const mutation = useMutation({
    mutationFn: (id: string) => API.deleteCard(id),
    onSuccess: () => {
      onSuccess();
    },
  });

  return {
    deleteCard: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
